export class ContactNotFoundException extends Error {}
export class ContactAlreadyRegistrated extends Error {}
